import { StatePlaceholder } from '../../../cdl/StatePlaceholder/StatePlaceholder';
import { translate } from '../../../common/helpers/translate.helper';
import { IconContract } from '../../../common/icons/cdl/Contract';
import { Box } from '../../../common/ui/Box';

export const ContractsEmptyState = () => {
    return (
        <Box marginTop="124px" display="flex" justifyContent="center">
            <StatePlaceholder
                Icon={IconContract}
                title={translate('contracts.emptyState.title')}
                description={translate('contracts.emptyState.description')}
            />
        </Box>
    );
};
